export default __webpack_public_path__ + "static/media/InactiveCalendarMonthRounded.c9696a80.svg";